<template>
  <b-modal
      id="add-asin-modal"
      centered
      :title="$t('pages.review.product_tracking.title')"
      title-class="font-18"
      size="xl"
      @hidden="handleHide"
  >
    <b-card-body>
      <div>
        <b-row class="justify-content-between">
          <b-col sm="8">
            <p>
              <i class="mdi mdi-alert-circle-outline me-2"></i>
              {{ $t('pages.review.product_tracking.info') }}
            </p>
          </b-col>
          <b-col sm="3" class="quota-end">
            <remaining :total="total" :used="newUse + used"></remaining>
          </b-col>
          <b-col sm="12">
            <b-card no-body class="shadow-none bg-light">
              <b-card-body>
                <div>
                  <b-row class="justify-content-between">
                    <b-col sm="4">
                      <h4 class="card-title mt-2">{{ $t('pages.review.product_tracking.your_products') }}</h4>
                    </b-col>
                    <b-col sm="5">
                      <data-table-search
                          v-model="search"
                          :placeHolder="$t('pages.review.product_tracking.search')"
                      />
                    </b-col>
                  </b-row>
                </div>
                <simplebar class="area">
                  <div class="row">
                    <b-col sm="12" lg="4" xl="4" md="12" v-for="(product,index) in catalogGroup" :key="index">
                      <div>
                        <label class="mb-2">
                          <input
                              @click="selectAsin(index)"
                              type="checkbox"
                              name="currency"
                              style="display: none"
                              v-model="product.selected"
                              :disabled="selectedAsins[product.marketplace_id + '%' + product.asin] === 'new'"
                          />
                          <b-card class="product-card"
                                  :class="{
                            'product-selected' : selectedAsins[product.marketplace_id + '%' + product.asin],
                            'disabled' : selectedAsins[product.marketplace_id + '%' + product.asin] === 'new',
                          }">
                            <div>
                              <div class="media">
                                <div class="me-3">
                                  <b-avatar
                                      :src="product.image_url"
                                      size="4.5rem"
                                      variant="light"
                                      class="img-thumbnail product-img"
                                  />
                                </div>
                                <div class="media-body align-self-center">
                                  <div class="text-muted">
                                    <h6 class="item-name">{{ product.item_name }}</h6>
                                    <p class="mb-1">ASIN: {{ product.asin }}</p>
                                  </div>
                                  <div class="mt-2">
                                    <market-place-chip :market-place-id="product.marketplace_id"></market-place-chip>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-card>
                        </label>
                      </div>
                    </b-col>
                    <!-- end col -->
                  </div>

                  <div class="text-center my-3">
                    <infinite-loading @infinite="infiniteHandler"
                                      :identifier="infiniteId"
                    >
                      <div slot="spinner">
                        <b-spinner></b-spinner>
                      </div>
                      <div slot="no-more">{{ $t('pages.review.product_tracking.no_more') }}</div>
                      <div slot="no-results">{{ $t('pages.review.product_tracking.no_product') }}</div>
                    </infinite-loading>
                  </div>
                </simplebar>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-card-body>

    <template #modal-footer="{ cancel }">
      <b-button variant="danger" @click="cancel()">
        {{ $t('pages.review.product_tracking.cancel') }}
      </b-button>
      <b-button variant="primary" :disabled="loading" @click="handleOk">
        <b-spinner v-if="loading" small></b-spinner>
        {{ $t('pages.review.product_tracking.track_products') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import MarketPlaceChip from "../../../components/widgets/MarketPlaceChip";
import DataTableSearch from "../../../components/DataTableSearch";
import simplebar from "simplebar-vue";
import InfiniteLoading from "vue-infinite-loading";
import ProductService from "../../../Services/Api/ProductService";
import Remaining from "../../../components/Remaining";
import QuotaMixin from "../../../mixins/QuotaMixin";

export default {
  name: "AddAsinModal",
  components: {Remaining, MarketPlaceChip, DataTableSearch, simplebar, InfiniteLoading},
  mixins: [QuotaMixin],
  data() {
    return {
      catalogGroup: [],
      selectedAsins: {},
      paginate: 50,
      page: 1,
      search: '',
      newUse: 0,
      infiniteId: 0,
      loading: false,
      quotaType: 'product_track'
    }
  },
  watch: {
    search() {
      this.page = 1;
      this.catalogGroup = [];
      this.infiniteId += 1;
    }
  },
  methods: {
    selectAsin(index) {
      if ((this.newUse + this.used === this.total)
          &&
          !this.selectedAsins[this.catalogGroup[index].marketplace_id + '%' + this.catalogGroup[index].asin]) {
        return
      }

      if (this.selectedAsins[this.catalogGroup[index].marketplace_id + '%' + this.catalogGroup[index].asin]) {

        delete this.selectedAsins[this.catalogGroup[index].marketplace_id + '%' + this.catalogGroup[index].asin]
        this.newUse -= 1
      } else {
        if (this.newUse === this.total) {
          return false
        }
        this.selectedAsins[this.catalogGroup[index].marketplace_id + '%' + this.catalogGroup[index].asin] = true
        this.newUse += 1
      }
    },
    async infiniteHandler(state) {
      if (this.page > 1 && (this.catalogGroup.length < this.paginate)) {
        state.complete()
        return
      }

      await ProductService.trackingProducts({query: `perPage=${this.paginate}&page=${this.page}&filter=${this.search}`}).then((res) => {
        const data = res.data.data

        if (data.length) {
          this.page += 1;
          res.data.tracked.forEach(item => {
            if (!this.selectedAsins.hasOwnProperty(item.marketplace_id + '%' + item.asin)) {
              this.selectedAsins[item.marketplace_id + '%' + item.asin] = 'new'
            }
          })

          this.catalogGroup.push(...data);
          state.loaded();
        } else {
          state.complete();
        }
        res.data.data
      })
    },
    handleHide() {
      this.catalogGroup = []
      this.selectedAsins = {}
      this.page = 1
      this.search = ''
      this.newUse = 0
      this.infiniteId = 0
    },
    async handleOk() {
      this.loading = true
      const products = []
      const values = Object.keys(this.selectedAsins)
      values.map(item => {
        const product = item.split('%')

        products.push({
          asin: product[1],
          marketplace_id: product[0]
        })
      })

      if (products.length > 0) {
        await ProductService.store({
          payload: {
            products
          }
        }).then(() => {
          this.$bvModal.hide('add-asin-modal')
        }).finally(() => {
          this.loading = false
        })
      }
      this.$bvModal.hide('add-asin-modal')
      this.loading = false
      this.$emit('track')
    }
  }
}
</script>
<style>
.area {
  height: 300px !important;
  padding: 12px;
}

.product-card {
  cursor: pointer;
}

.product-selected {
  border: 1px solid #34c38f;
}
</style>